import React from "react";
import FormContainer from "./formContainer";
import { LocalStorageItem, RoutePath } from "../models/enums";
import { useQueryLogin } from "../hooks/queries";
import { Domain, FormEmail } from "../models/types";
import { IQueryLogin, IQueryLoginResponse } from "../hooks/queries/useQueryLogin";
import { IQueryResponse } from "taskpane/models/interfaces";
import { getQueryErrorInvalidLoginOrPassword } from "taskpane/resources";
import { useLoading } from "../providers/loadingProvider";
import "../styles/inputField.css";
import { useHistory } from "react-router-dom";
import { IApiParams, useApiContext } from "taskpane/providers/apiProvider";

export interface IPasswordForm extends FormEmail, Domain {}

const PasswordForm: React.FC<IPasswordForm> = (props: IPasswordForm): React.JSX.Element => {
  const { setLoading } = useLoading();
  const { apiUrl, fetchConfig } = useApiContext();
  const history = useHistory();
  const [password, setPassword] = React.useState<string>("");
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const [isDisabledButton, setIsDisabledButton] = React.useState<boolean>(true);
  const onChangePassword = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const passwordValue: string = e.target.value;

    setIsDisabledButton(!passwordValue);
    setPassword(passwordValue);
  };
  const submitQueryLogin = (apiUrl: string, domain: string): void => {
    const { email } = props;

    const queryLoginParams: IQueryLogin = {
      apiUrl: apiUrl,
      email: email,
      password: password,
    };

    useQueryLogin(queryLoginParams, ({ response, errorMessage }: IQueryResponse<IQueryLoginResponse>) => {
      setLoading(false);

      if (errorMessage) {
        return setErrorMessage(errorMessage);
      }

      const { data } = response.response;
      const token: string = data?.token?.a;

      if (!token) {
        return setErrorMessage(getQueryErrorInvalidLoginOrPassword());
      }

      setErrorMessage("");

      localStorage.setItem(LocalStorageItem.token, token);
      localStorage.setItem(LocalStorageItem.email, email);
      localStorage.setItem(LocalStorageItem.domain, domain);

      history.push(RoutePath.conferencePage);
    });
  };
  const onSubmitForm = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();

    const { domain } = props;

    setLoading(true);

    if (!apiUrl) {
      fetchConfig(domain, ({ apiUrl, errorMessage }: IApiParams) => {
        if (errorMessage) {
          setErrorMessage(errorMessage);
          return setLoading(false);
        }

        submitQueryLogin(apiUrl, domain);
      });
    } else {
      submitQueryLogin(apiUrl, domain);
    }
  };

  return (
    <FormContainer
      title="Введите пароль"
      description={`Введите одноразовый пароль, который был отправлен на ${props.email}`}
      errorText={errorMessage}
      isDisabledButton={isDisabledButton}
      onSubmitForm={onSubmitForm}
    >
      <input
        type="password"
        name="password"
        value={password}
        onChange={(e) => onChangePassword(e)}
        className="inputField"
        id="passwordField"
        placeholder="Пароль"
        required
        data-testid="passwordField"
      />
    </FormContainer>
  );
};

export default PasswordForm;
